import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y-2 border-volt/25 bg-carbon" data-id="element-41" data-mp="2bju8fjocf3ie">
      <div className="mx-auto max-w-3xl px-3 py-8 sm:px-6 sm:py-10" data-id="element-42" data-mp="2fmh27q4kqyi8">
        <Reveal data-id="element-43" data-mp="2fns6rs5ugaae">
          <SectionHeading id="faq" title="Preguntas frecuentes" data-id="element-44" data-mp="21usr9q62ag2u" />
        </Reveal>

        <div className="mt-4 grid gap-1.5" data-id="element-45" data-mp="21sq218cqgqz6">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-lg border border-white/10 bg-night" data-id="element-46" data-mp="2ui6si0gslxsr" data-mpi={i}>
                <h3 data-id="element-47" data-mp="2zc19ux8xe0oo">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-3 text-left sm:px-4" data-id="element-48" data-mp="1vprcz2qi0yp1">
                    <span className="text-[0.82rem] font-bold text-white sm:text-sm" data-id="element-49" data-mp="20o2n7ekphb7s">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={17} className={`flex-shrink-0 text-volt transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" data-mp="2aentlo6mfk19" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-51" data-mp="tzvxb06ctsmo">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-52" data-mp="p1ce37j5auy0">
                      <p className="px-3 pb-3 text-[0.8rem] leading-snug text-steel sm:px-4 sm:text-sm" data-id="element-53" data-mp="2z44anxp14s2k">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}